import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ApiError } from '../../../api/client';

export const errMsg = (e: unknown, fallback: string) => (e instanceof ApiError ? e.message : fallback);

export function AuthorityNav({ current }: { current: string }) {
  const items: [string, string][] = [
    ['/admin/authority', 'Overview'], ['/admin/authority/positions', 'Positions'], ['/admin/authority/reporting', 'Reporting Structure'],
    ['/admin/authority/access-profiles', 'Access Profiles'], ['/admin/authority/approval-rules', 'Approval Rules'], ['/admin/authority/responsibilities', 'Responsibilities'],
    ['/admin/authority/acting', 'Acting Appointments'], ['/admin/delegations', 'Delegations'], ['/admin/authority/tester', 'Authority Tester'],
    ['/admin/authority/health', 'Governance Health'], ['/admin/authority/reconciliation', 'Reconciliation'], ['/admin/audit', 'Audit'],
  ];
  return (
    <nav className="authority-nav">
      {items.map(([to, label]) => <Link key={to} to={to} className={'authority-nav-link' + (current === to ? ' authority-nav-link-active' : '')}>{label}</Link>)}
    </nav>
  );
}

export function Pill({ tone, children }: { tone: 'ok' | 'warn' | 'bad' | 'info' | 'muted'; children: ReactNode }) {
  return <span className={`auth-pill auth-pill-${tone}`}>{children}</span>;
}
